import './logo-section.scss';
import 'slick-carousel';
import AOS from 'aos';
export default (() => {
  if ($('#partners_logo__slider').length > 0) {
    $('#partners_logo__slider').slick({
      rows: 2,
      dots: false,
      arrows: true,
      infinite: false,
      variableWidth: true,
      prevArrow: '.partners_logo__prev',
      nextArrow: '.partners_logo__next',
      slidesToShow: 1,
      appendDots: $('.logo-section__dots'),
      dotsClass: 'slider-dots'
    });
  }
  if ($('#customers_logo__slider').length > 0) {
    $('#customers_logo__slider').slick({
      rows: 2,
      dots: false,
      arrows: true,
      infinite: false,
      variableWidth: true,
      prevArrow: '.customers_logo__prev',
      nextArrow: '.customers_logo__next',
      slidesToShow: 1,
      appendDots: $('.logo-section__dots'),
      dotsClass: 'slider-dots'
    });
  }
  AOS.init({
    once: true
  });
});